export const LIVE_SEEK_SET_DURATION_ERROR = 'liveSeek.setDuration.error';
export const LIVE_SEEK_PLAY_ERROR = 'liveSeek.play.error';
export const LIVE_SEEK_LOAD_ERROR = 'liveSeek.load.error';
export const LIVE_SEEK_SEEK_ERROR = 'liveSeek.seek.Error';
